export default __webpack_public_path__ + "d9124516cc6f6f9c62e11b51187bc419.png";